import {
  SlAlert
} from "./chunk.D4YH5HPE.js";

// src/components/alert/alert.ts
var alert_default = SlAlert;
SlAlert.define("sl-alert");

export {
  alert_default
};
